import { QueryClient } from '@tanstack/react-query';

export class QueryStateManagement {
  static #instance: QueryStateManagement;
  queryClient: QueryClient | null = null;

  private constructor() {}

  public static get instance(): QueryStateManagement {
    if (!QueryStateManagement.#instance) {
      QueryStateManagement.#instance = new QueryStateManagement();
    }

    return QueryStateManagement.#instance;
  }

  public static get client() {
    if (!QueryStateManagement.instance.queryClient) {
      QueryStateManagement.instance.queryClient = new QueryClient();
    }
    return QueryStateManagement.instance.queryClient;
  }
}
